import alt from '../alt';
import userSetAction from '../actions/userSetAction';

class userSetStore {
    constructor() {
        this.bindActions(userSetAction);
        //userDetail
        this.userDetail = {supervisor:[],comHandphone:{},comLaptop:{},comCabcard:{}};
        //to determine whether user is communicate with server
        this.processing = false;
        
        this.isSucceed = false;
        //to determine whether it is add or edit user
        this.usMode = 0;
        this.warningMsg = "";
        this.search = "";
        //to edit staff
        this.staffId = "";
        this.permissionList =[];
        this.updating = false;
        this.team = [];
        this.removedTeam = [];
    }

    
    onUsMode(data) {
        this.usMode = data;
    }
    onWarningMsg(data) {
        this.warningMsg = data;
    }
    onStaffId(data) {
        this.staffId = data;
    }
    onClear(){
        this.userDetail= {supervisor:[],comHandphone:{},comLaptop:{},comCabcard:{}};
    }
    onUserImage(url) {
        this.userImage = url;
    }
    onProcessing(data) {
        this.processing = data;
    }
    onUpdateSuccess(data) {
        this.isSucceed = true;
    }
    onAddSuccess(data) {
        this.isSucceed = true;
    }
    userDetailSuccess(data) {
        this.userDetail = data;
    }
    onRemoveSuccess(data) {
        this.isSucceed = true;
    }
    onIsSucceed(data) {
        this.isSucceed = data;
    }
    onSearch(data) {
        this.search = data;
    }
    onUpdating(data) {
        this.updating = data;
    }
    onUpdateUserDetail(data){
        console.log(data);
        this.userDetail = data;
    }
    onSupervisor(data){
        console.log('pass here');
        this.userDetail.supervisor = data;
    }
    onPermissionListSuccess(data){
        this.permissionList = data;
    }
    onPermission(data){
        this.userDetail.permission = data;
    }
    onTeam(data){
        this.team = data;
    }
    onRemovedTeam(data){
        this.removedTeam = data;
    }
}
export default alt.createStore(userSetStore, 'userSetStore');


// WEBPACK FOOTER //
// ./app/stores/userSetStore.js